module.exports = __webpack_public_path__ + "static/media/firefox.8ed9514e.png";